import React, { useState, useEffect } from "react";
import { Button } from "./button";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "./select";
import { Search } from "lucide-react";
import { getOccupations, getCities } from "../utils/api";

export default function MatrimonySearch({ onSearch }) {
  const [lookingFor, setLookingFor] = useState("");
  const [ageRange, setAgeRange] = useState({ min: "", max: "" });
  const [occupation, setOccupation] = useState("");
  const [city, setCity] = useState("");
  const [occupations, setOccupations] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    getOccupations().then(setOccupations).catch((e) => console.error(e));
    getCities().then(setCities).catch((e) => console.error(e));
  }, []);

  const handleClick = () => {
    onSearch({ lookingFor, ageRange, occupation, city });
  };

  return (
    <section className="py-10 px-4">
      <div className="container max-w-5xl mx-auto">
        <div className="bg-white rounded-3xl shadow-2xl p-6 mb-16 border border-rose-100">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {/* Looking For */}
            <Select value={lookingFor} onValueChange={setLookingFor}>
              <SelectTrigger className="h-10 rounded-xl border-gray-200 focus:border-rose-500 px-3">
                <SelectValue placeholder="Looking For" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Bride">Bride</SelectItem>
                <SelectItem value="Groom">Groom</SelectItem>
              </SelectContent>
            </Select>

            {/* Age Range Inputs */}
            <div className="flex space-x-2">
              <input
                type="number"
                placeholder="Min Age"
                value={ageRange.min}
                onChange={(e) =>
                  setAgeRange({
                    ...ageRange,
                    min: Math.max(1, parseInt(e.target.value) || 1),
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") e.preventDefault();
                }}
                min="1"
                className="h-10 w-full border border-gray-200 rounded-xl px-3 appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              />
              <input
                type="number"
                placeholder="Max Age"
                value={ageRange.max}
                onChange={(e) =>
                  setAgeRange({
                    ...ageRange,
                    max: Math.max(1, parseInt(e.target.value) || 1),
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") e.preventDefault();
                }}
                min="1"
                className="h-10 w-full border border-gray-200 rounded-xl px-3 appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              />
            </div>

            {/* Occupation Select */}
            <Select
              value={occupation}
              onValueChange={(value) => {
                const selectedOcc = occupations.find(occ => occ.title === value);
                setOccupation(selectedOcc?._id || "");
              }}
            >
              <SelectTrigger className="h-10 rounded-xl border-gray-200 focus:border-rose-500 px-3">
                <SelectValue placeholder="Occupation">
                  {occupations.find(o => o._id === occupation)?.title || "Occupation"}
                </SelectValue>
              </SelectTrigger>
              <SelectContent>
                {occupations.map((occ) => (
                  <SelectItem key={occ._id} value={occ.title}>
                    {occ.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            {/* City Select */}
            <Select
              value={city}
              onValueChange={(value) => {
                const selectedCity = cities.find(c => c.name === value);
                setCity(selectedCity?._id || "");
              }}
            >
              <SelectTrigger className="h-10 rounded-xl border-gray-200 focus:border-rose-500 px-3">
                <SelectValue placeholder="City">
                  {cities.find(c => c._id === city)?.name || "City"}
                </SelectValue>
              </SelectTrigger>
              <SelectContent>
                {cities.map((c) => (
                  <SelectItem key={c._id} value={c.name}>
                    {c.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            {/* Search Button */}
            <Button className="h-10 rounded-xl shadow-lg flex items-center justify-center" onClick={handleClick}>
              <Search className="w-4 h-4 mr-1" />
              Search
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
